import { render, staticRenderFns } from "./ClientConflictList.vue?vue&type=template&id=70a8fe58&"
import script from "./ClientConflictList.vue?vue&type=script&lang=js&"
export * from "./ClientConflictList.vue?vue&type=script&lang=js&"
import style0 from "./ClientConflictList.vue?vue&type=style&index=0&id=70a8fe58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports